import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {BsModalService} from 'ngx-bootstrap/modal';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {Logger, TitleService} from '@common-lib';
import {ActivatedRoute} from '@angular/router';
import {UsersService} from '../../pages-services/users.service';
import {ToasterService} from 'angular2-toaster';
import {TranslateService} from "@ngx-translate/core";
import {ConfirmPopupComponent} from "../../components/confirm-popup/confirm-popup.component";
import {MarketsService} from '../../pages-services/markets.service';

@Component({
    selector: 'app-settings-markets',
    templateUrl: './settings-markets.component.html',
    styleUrls: ['./settings-markets.component.scss']
})
export class SettingsMarketsComponent implements OnInit {

    editModalRef: BsModalRef;
    selectedRow: {
        id?:number,
        title: string,
        language: string,
        isActive: string|boolean,
        dateFormat: string,
        currencyFormat: string,
        regions: string,
        segments: string,
        side: string,
        locales: string | Array<string>
        new: boolean
    };
    searchTerm = '';

    @ViewChild('editFormTemplate')
    editFormTemplate: TemplateRef<any>;

    all_segments = [
      'long_haul', 'regional_haul', 'mining_and_quary', 'building_and_construction'
    ];

    all_side = [
      'lhd', 'rhd'
    ];

    locales = [
        'nl-nl',
        'nl-be',
        'en-au',
        'en-bz',
        'en-ca',
        'en-us',
        'en-gb',
        'fr-be',
        'fr-ca',
        'fr-fr',
        'fr-ch',
        'de-at',
        'de-de',
        'de-ch',
        'es-ar',
        'es-es',
        'sv-fi',
        'sv-se',
        'pt-pt',
        'it-it',
        'it-ch'
    ];

    tableConfiguration = {
        searchEnabled: false,
        headerEnabled: true,
        orderEnabled: true,
        globalSearchEnabled: false,
        paginationEnabled: true,
        exportEnabled: false,
        clickEvent: false,
        selectRow: false,
        selectCol: false,
        selectCell: false,
        rows: 50,
        additionalActions: false,
        serverPagination: false,
        isLoading: false,
        detailsTemplate: false,
        groupRows: false,
        paginationRangeEnabled: true,
        collapseAllRows: false,
        checkboxes: false
    };

    columns = [
        {key: 'icon', title: ''},
        {key: 'title', title: 'Title'},
        {key: 'language', title: 'Language'},
        {key: 'dateFormat', title: 'Date Format'},
        {key: 'url', title: 'Url'},
        // {key: 'currencyFormat', title: 'Currenty Format'},
        {key: 'locales', title: 'Locales'},
        {key: 'regions', title: 'Regions'},
        {key: 'segments', title: 'Segments'},
        {key: 'side', title: 'Side'},
        {key: 'isActive', title: 'Is Active'},
        {key: 'actions', title: ''}

    ];
    data = [];
    rows = [];
    selected = new Set();

    @ViewChild(ConfirmPopupComponent)
    confirmPopup: ConfirmPopupComponent;

    constructor(
        private route: ActivatedRoute,
        private marketsService: MarketsService,
        private modalService: BsModalService,
        private logger: Logger,
        private toasterService: ToasterService,
        private translationService: TranslateService
    ) {
    }

    ngOnInit() {
        this.getList();
    }

    getList() {
        this.marketsService.getList().subscribe((data) => {
            this.data = data;
            this.search();
        });
    }

    editRow(row) {
        this.selectedRow = row;
        this.selectedRow.locales = typeof this.selectedRow.locales === 'string' ? (this.selectedRow.locales as string).split(',') : this.selectedRow.locales;
        this.editModalRef = this.modalService.show(this.editFormTemplate);
    }

    rowSelected(event) {
        if (event.event === 'onDoubleClick') {
            this.editRow(event.value.row);
        }
    }

    async saveUserData() {
        let sendObj = Object.assign({}, this.selectedRow);

        sendObj.isActive = sendObj.isActive === 'Yes' || sendObj.isActive === true ? true : false;
        if (sendObj.new) {
            this.marketsService
                .create(sendObj)
                .subscribe(async (result) => {
                    this.getList();
                    this.toasterService.pop('success', '', await this.translationService.get('webpanel.markets.market_created_message').toPromise());
                    this.editModalRef.hide();
                }, (err) => {
                    this.toasterService.pop('error', '', err.message);
                });

        } else {
            this.marketsService
                .update(sendObj)
                .subscribe((result) => {
                    this.marketsService
                        .getList()
                        .subscribe(async (data) => {
                            this.data = data;
                            this.search();
                            this.toasterService.pop('success', '', await this.translationService.get('webpanel.markets.market_updated_message').toPromise());
                            this.editModalRef.hide();
                        });
                });
        }

    }

    search() {
        this.rows = this.data.filter((r) => this.searchTerm.length === 0 ||
            r.title.indexOf(this.searchTerm.toLowerCase) !== -1 ||
            r.language.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1);

        this.rows = this.rows.map((u) => ({
            ...u,
            isActive: u.isActive ? 'Yes' : 'No'
        }));
    }

    addNew() {
        this.selectedRow = {
            title: '',
            isActive: 'Yes',
            language: 'en',
            dateFormat: 'DD/MM/YYYY',
            currencyFormat: '### ###.##',
            locales: [],
            regions: '',
            segments: '',
            side: 'lhd',
            'new': true
        };
        this.editModalRef = this.modalService.show(this.editFormTemplate);
    }

    searchKeyPress(event) {
        if (event.which === 13) {
            this.search();
        }
    }

    async removeItem(item) {
        this.selectedRow = item;
        let confirmMessage;
        if (this.selectedRow) {
           this.confirmPopup.show();
        }
    }

    confirm(res) {
        if(res) {
            if (this.selectedRow) {
                this.marketsService.delete(this.selectedRow).subscribe(async (resp) => {
                    this.selectedRow = null;
                    let successMessage = await this.translationService.get('webpanel.markets.delete.success_message').toPromise();
                    this.toasterService.pop('success', '', successMessage);
                    this.getList();
                });
            }
        }else {
            this.selectedRow = null;
        }
    }

    decline() {
        this.selectedRow = null;
    }

    activeChecked(e) {
      this.selectedRow.isActive = e.target.checked ? 'Yes' : 'No';
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/settings-markets/settings-markets.component.ts